import * as http from '@/shared/http'
import { store } from '@/shared/store'

const goldConst = {
  BASE_URL: process.env.VUE_APP_METAL_URL,
  TIMEOUT: 30000, // Milliseconds
}

function getOptions() {
  let options = {
    baseURL: goldConst.BASE_URL,
    headers: getHeaders(),
    timeout: goldConst.TIMEOUT,
  }
  return options
}

function getHeaders(multipart = false) {
  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  }

  if (multipart) {
    headers = {}
  }

  if (localStorage.userToken) {
    headers['Authorization'] = `Bearer ${localStorage.userToken}`
  }

  return headers
}

export function handleError(error) {
  let errMsg = 'Internal server error'

  if (error.response) {
    if (error.response.data.message) {
      errMsg = error.response.data.message
    } else {
      errMsg = error.response.statusText
    }

    if (error.response.status === 401) {
      localStorage.clear()
      errMsg = 'Session is expired. Please refresh the page.'
    }
  } else {
    if (error.message){
      errMsg = error.message
    }
  }

  window.scrollTo(0,0)
  store.showAlert(errMsg, 'danger')
  return
}

/** API URI **/

/* AUTH */
export function requestOtp(email) {
  const data = http.toUrlEncoded({email})
  return http.post('/v1/dashboard/send_otp', data, getOptions())
}

export function verifyOtp(email, otp_code) {
  const data = http.toUrlEncoded({email, otp_code})
  return http.post('/v1/dashboard/verify_otp', data, getOptions())
}

export function login(email, password) {
  const data = http.toUrlEncoded({email, password})
  return http.post('/v1/dashboard/login', data, getOptions())
}

export function logout() {
  return http.post('/v1/dashboard/logout', {}, getOptions())
}

/* PARTNERS/USERS */
export function getPartnerInfo() {
  return http.get('/v1/dashboard/users', {}, getOptions())
}

export function marginSimulation(buy_margin, sell_margin) {
  const data = http.toUrlEncoded({buy_margin, sell_margin})
  return http.post('/v1/dashboard/update_margin_simulations', data, getOptions())
}

export function updateMargin(buy_margin, sell_margin) {
  const data = http.toUrlEncoded({buy_margin, sell_margin})
  return http.post('/v1/dashboard/update_margins', data, getOptions())
}

export function uploadImage(file) {
  return http.post('/v1/dashboard/upload_images', file, getOptions())
}

/* CUSTOMERS */
export function getCustomersList(params) {
  return http.get('/v1/dashboard/daily_saldo_customers', params, getOptions())
}

/* ORDERS */
export function getOrdersList(params) {
  return http.get('/v1/dashboard/savings_orders', params, getOptions())
}

/* DISBURSES */
export function getDisburseList(params) {
  return http.get('/v1/dashboard/savings_disbursements', params, getOptions())
}

/* SHIPPINGS */
export function getShippingsList(params) {
  return http.get('/v1/dashboard/savings_shippings', params, getOptions())
}

export function getProvinces() {
  return http.get('/v1/dashboard/provinces', {}, getOptions())
}

export function getCities(params) {
  return http.get('/v1/dashboard/cities', params, getOptions())
}

export function getDistricts(params) {
  return http.get('/v1/dashboard/districts', params, getOptions())
}

/* DEPOSITS */
export function getDepositList(params) {
  return http.get('/v1/dashboard/deposits', params, getOptions())
}

export function getBankAccounts() {
  return http.get('/v1/dashboard/bank_accounts', {}, getOptions())
}

export function requestTopUpDeposit(params) {
  const data = http.toUrlEncoded(params)
  return http.post('/v1/dashboard/top_up_deposits', data, getOptions())
}

export function getTopUpDepositsList(params) {
  return http.get('/v1/dashboard/top_up_deposits', params, getOptions())
}

 /* INCENTIVES */
 export function getIncentiveList(params) {
  return http.get('/v1/dashboard/incentives', params, getOptions())
}

 export function getAllBanks() {
  return http.get('/v1/dashboard/banks', {}, getOptions())
}

export function requestIncentiveSaldo(params) {
  const data = http.toUrlEncoded(params)
  return http.post('/v1/dashboard/request_incentives', data, getOptions())
}

export function getRequestIncentivesList(params) {
  return http.get('/v1/dashboard/request_incentives', params, getOptions())
}

/* DOWNLOADS */

export function getCustomersListCsv(params) {
  return http.get('/v1/dashboard/download_daily_saldo_customers', params, getOptions())
}

export function getOrdersListCsv(params) {
  return http.get('/v1/dashboard/download_orders', params, getOptions())
}

export function getDisbursesListCsv(params) {
  return http.get('/v1/dashboard/download_disbursements', params, getOptions())
}

export function getShippingsListCsv(params) {
  return http.get('/v1/dashboard/download_shippings', params, getOptions())
}
